import { BettingOfferKeyDelete } from "./BettingOfferKeyDelete";
import { BettingOfferKeyUpdate } from "./BettingOfferKeyUpdate";
import { Event } from "./Event";
import { IChange } from "./IChange";

export class EventUpdate {
    eventId: string;
    event: Event;
    offers?: IChange<BettingOfferKeyUpdate, BettingOfferKeyDelete>;
}